import { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import LoggedLayout from 'layouts/LoggedLayout';
import EmpoweredSelector from 'components/EmpoweredSelector';
import PageHeader from 'components/PageHeader';
import { hasCapability } from 'helpers/user';
import { default as StationsService } from 'services/Stations';
import { default as PricesService } from 'services/Prices';

let axiosCancelToken = null;

export default function PricesCheckForm() {
	const navigate = useNavigate();

	let [data, setData] = useState({
		station: null,
		date: moment().format('YYYY-MM-DD HH:mm')
	});
	const [errors, setErrors] = useState({});

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	const saveData = async () => {
		setErrors({});

		data.manual = true; // Set manual on DB

		let result = await PricesService.addCheck(data);
		if ( result.errors ) {
			setErrors(result.errors);
			toast.error('Ha ocurrido un error al guardar');
		} else {
			toast.success('Datos guardados');
			navigate('/prices-check');
		}
	}

	const setDataField = (field, value) => {
		setData((prev) => ({...prev, [field]: value}));
	}

	const loadStations = async (input, callback) => {
		let stations = await StationsService.getList({
			search: input,
			no_paginate: true
		});
		
		callback(stations?.map(el => {
			return {
				value: el,
				label: el.name
			}
		}));
	}

	const selectStation = (value) => {
		setData({...data, station: value, station_id: value?.id});
	}

	return (
		<LoggedLayout>
			<PageHeader className="mb-3" style={{ maxWidth: '700px', margin: 'auto' }}>
				<NavLink to={-1} className="btn-sm btn-light p-0 px-2 float-start" style={{
					border: '1px solid var(--plenoil-black)',
					background: 'transparent',
					borderRadius: '100%',
					width: '25px',
					height: '25px',
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'nowrap',
					justifyContent: 'center',
					alignItems: 'center',
					marginRight: '5px'
				}}>
					<i className="bi bi-chevron-left" style={{
						fontSize: '1rem',
						lineHeight: '100%',
						color: 'var(--plenoil-black)'
					}}></i>
				</NavLink>
				<span className="header-column header-title">Envío manual</span>
				<span className="header-column header-icon-end">
					<i className="bi bi-truck text-plenoil-gray"></i>
				</span>
			</PageHeader>

			<div className="pt-2 col-md-12 h-100 row p-4 background-color-blanco shadow rounded" style={{ maxWidth: '700px', margin: 'auto' }}>
				<div className="col-md-3">
					<div className="mb-2">
						<label className='control-label'>Estación</label>
						<EmpoweredSelector
							load={(input, callback) => loadStations(input, callback)}
							onChange={(value, text) => selectStation(value)}
							timeout={200}
							label={data.station?.name}
							value={data.station?.id ?? null}
						/>
						{ errors.station_id &&
							<div className="invalid-feedback d-block">{ errors.station_id[0] }</div>
						}
					</div>
				</div>
				<div className="col-md-3">
					<div className="mb-2">
						<label className='control-label'>Fecha</label>
						<input type="datetime-local" className="form-control form-control-sm" onChange={(e) => setDataField('date', e.target.value)} value={data.date ?? ''} />
						{ errors.date &&
							<div className="invalid-feedback d-block">{ errors.date[0] }</div>
						}
					</div>
				</div>
				<div className="col-md-3">
					<div className="mb-2">
						<label className='control-label'>Precio GOA</label>
						<input type="number" step="0.001" className="form-control form-control-sm no-arrows" onChange={(e) => setDataField('goa_price', e.target.value)} value={data.goa_price ?? ''} />
						{ errors.goa_price &&
							<div className="invalid-feedback d-block">{ errors.goa_price[0] }</div>
						}
					</div>
				</div>
				<div className="col-md-3">
					<div className="mb-2">
						<label className='control-label'>Litros SP95</label>
						<input type="number" step="0.001" className="form-control form-control-sm no-arrows" onChange={(e) => setDataField('sp95_price', e.target.value)} value={data.sp95_price ?? ''} />
						{ errors.sp95_price &&
							<div className="invalid-feedback d-block">{ errors.sp95_price[0] }</div>
						}
					</div>
				</div>
				<div className="card-footer d-flex justify-content-between">
					<span>&nbsp;</span>

					{ hasCapability('tankertrucks', 'add') &&
						<button className="btn btn-sm btn-plenoil btn-plenoil-orange mb-2" style={{ width: 'max-content' }} onClick={() => saveData()}>Guardar</button>
					}
				</div>
			</div>
		</LoggedLayout>
	);
}


